import { Reveal } from "./Reveal";

const STATEMENTS = [
  "Я слишком много думаю перед принятием решений.",
  "Я не понимаю, чего хочу на самом деле.",
  "Мне сложно отличить своё желание от ожиданий окружающих.",
  "Я чувствую, что живу не совсем свою жизнь.",
  "Я хочу лучше понять себя и научиться на себя опираться.",
];

const OFFERS = [
  { t: "Ясность", d: "Лучшее понимание своей природы и внутренних механизмов." },
  { t: "Ориентир", d: "Понимание своей стратегии и способа принимать решения." },
  { t: "Опора", d: "Возможность лучше слышать себя и замечать влияние внешних ожиданий." },
  { t: "Эксперимент", d: "Возможность наблюдать за собой и постепенно проверять знания на практике." },
];

export const WhoFor = () => (
  <section data-testid="who-for-section" className="mx-auto max-w-[1240px] px-6 py-28 md:px-10 md:py-40">
    <div className="grid gap-12 md:grid-cols-[0.9fr_1.1fr] md:gap-20">
      <Reveal>
        <div className="md:sticky md:top-28 md:self-start">
          <span className="font-serif text-7xl italic text-sand md:text-8xl">02</span>
          <h2 className="mt-6 font-serif text-4xl leading-tight tracking-tight text-charcoal md:text-5xl">
            Возможно, Вам знакомо…
          </h2>
        </div>
      </Reveal>

      <div className="divide-y divide-charcoal/10 border-t border-charcoal/10">
        {STATEMENTS.map((s, i) => (
          <Reveal key={i} delay={i * 0.06}>
            <div className="group flex items-baseline gap-6 py-7">
              <span className="font-sans text-sm text-sage">{String(i + 1).padStart(2, "0")}</span>
              <p className="font-serif text-2xl leading-snug tracking-tight text-charcoal/85 transition-colors duration-300 group-hover:text-charcoal md:text-3xl">
                {s}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const WhatOffers = () => (
  <section data-testid="offers-section" className="bg-charcoal py-28 text-ivory md:py-40">
    <div className="mx-auto max-w-[1240px] px-6 md:px-10">
      <Reveal>
        <p className="font-sans text-xs uppercase tracking-[0.32em] text-sage">Индивидуальное чтение</p>
        <h2 className="mt-6 max-w-2xl font-serif text-[1.8rem] leading-tight tracking-tight md:text-[3rem]">
          Что может дать индивидуальное чтение
        </h2>
      </Reveal>

      <div className="mt-20 grid gap-x-16 gap-y-14 sm:grid-cols-2">
        {OFFERS.map((o, i) => (
          <Reveal key={o.t} delay={i * 0.08}>
            <div className="border-t border-ivory/15 pt-7">
              <h3 className="font-serif text-[1.8rem] italic tracking-tight text-sand">{o.t}</h3>
              <p className="mt-4 max-w-sm font-sans text-base font-light leading-relaxed text-ivory/70">
                {o.d}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
